import React from 'react';
import HRBranchPage from '../../pages/hr/branch-management';
import ViewBranchPage from '../../pages/hr/branch-management/view-branch';
import ProtectedRoute from '../protected';

export const HRBranchesRoutes = [
  <ProtectedRoute exact path='/branch' component={HRBranchPage} />,
  <ProtectedRoute exact path='/branch/view/:id' component={ViewBranchPage} />,
];